/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Checkbox, Segment, Divider, Form, Dimmer, Loader, Container } from "semantic-ui-react";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";
//import { Netmask } from "netmask";
// eslint-disable-next-line no-undef
var Netmask = require("netmask").Netmask;

const UtilsInstance = new Utils();

class Sweep extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isManualSweepChecked: false,
      subNetworkData: [],
      isSweepDimmerActive: false,
      monitorIP: -1,
      monitorMask: -1,
      networkNetmask: ""
    };
  }

  showSweepDimmer = () => this.setState({ isSweepDimmerActive: true })
  hideSweepDimmer = () => this.setState({ isSweepDimmerActive: false })

  retrieveData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "getSubNetworkSweepData", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        isManualSweepChecked: !data.default,
        subNetworkData: data.subNetworkData
      }, () => {
        this.setCheckboxesLabels();
        this.fillNetworkRangeFormInputs();
      }));

    fetch(Constants.REQUEST_IP_ADDRESS + "config", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        monitorIP: data.addr,
        monitorMask: data.netmask
      }, () => {
        this.setState({ networkNetmask: new Netmask(this.state.monitorIP + "/" + this.state.monitorMask) });
      }));
  }

  setCheckboxesLabels = () => {
    if (this.state.isManualSweepChecked) {
      document.getElementById("manual-checkbox-label").innerText = Strings.SWEEP_ON;
    }
    else {
      document.getElementById("manual-checkbox-label").innerText = Strings.SWEEP_OFF;
    }
  }

  fillNetworkRangeFormInputs = () => {
    if (this.state.subNetworkData !== null) {
      if (this.state.subNetworkData[0] !== null & this.state.subNetworkData[0] !== undefined) {
        document.getElementById("subnetwork-1").value = this.state.subNetworkData[0].subNetwork;
        document.getElementById("first-ip-1").value = this.state.subNetworkData[0].firstIp;
        document.getElementById("last-ip-1").value = this.state.subNetworkData[0].lastIp;
      }

      if (this.state.subNetworkData[1] !== null & this.state.subNetworkData[1] !== undefined) {
        document.getElementById("subnetwork-2").value = this.state.subNetworkData[1].subNetwork;
        document.getElementById("first-ip-2").value = this.state.subNetworkData[1].firstIp;
        document.getElementById("last-ip-2").value = this.state.subNetworkData[1].lastIp;
      }

      if (this.state.subNetworkData[2] !== null & this.state.subNetworkData[2] !== undefined) {
        document.getElementById("subnetwork-3").value = this.state.subNetworkData[2].subNetwork;
        document.getElementById("first-ip-3").value = this.state.subNetworkData[2].firstIp;
        document.getElementById("last-ip-3").value = this.state.subNetworkData[2].lastIp;
      }

      if (this.state.subNetworkData[3] !== null & this.state.subNetworkData[3] !== undefined) {
        document.getElementById("subnetwork-4").value = this.state.subNetworkData[3].subNetwork;
        document.getElementById("first-ip-4").value = this.state.subNetworkData[3].firstIp;
        document.getElementById("last-ip-4").value = this.state.subNetworkData[3].lastIp;
      }

      if (this.state.subNetworkData[4] !== null & this.state.subNetworkData[4] !== undefined) {
        document.getElementById("subnetwork-5").value = this.state.subNetworkData[4].subNetwork;
        document.getElementById("first-ip-5").value = this.state.subNetworkData[4].firstIp;
        document.getElementById("last-ip-5").value = this.state.subNetworkData[4].lastIp;
      }
    }
  }

  toggleCheckbox = () => {
    this.setState({
      isManualSweepChecked: !this.state.isManualSweepChecked,
    }, () => {
      this.setCheckboxesLabels();
    });
  }

  sendSweepInformation = () => {
    let sweepData = {
      default: !this.state.isManualSweepChecked,
      subNetworkData: []
    };

    let firstSubnetwork = {};
    let secondSubnetwork = {};
    let thirdSubnetwork = {};
    let fourthSubnetwork = {};
    let fifthSubnetwork = {};

    let doAddressFieldsHaveProblem = true;
    let alertMessage = Strings.ALERT_MESSAGE_PLACEHOLDER;
    let numOfLines = 0;

    if (!this.isLineBlank(1)) {
      if (this.isWholeLineFilled(1)) {
        if (this.isFirstAddressSmallerThanLast(
          document.getElementById("first-ip-1").value,
          document.getElementById("last-ip-1").value)) {
          if (this.isSubnetworkLineIPValid(1)) {
            numOfLines++;

            firstSubnetwork = {
              subNetwork: document.getElementById("subnetwork-1").value,
              firstIp: parseInt(document.getElementById("first-ip-1").value, 10).toString(),
              lastIp: parseInt(document.getElementById("last-ip-1").value, 10).toString()
            };

            sweepData.subNetworkData.push(firstSubnetwork);
          }
          else {
            doAddressFieldsHaveProblem = false;
            alertMessage = alertMessage.concat(Strings.FIRST_SUBNETWORK_ADDRESS_NOT_VALID);
          }
        }
        else {
          doAddressFieldsHaveProblem = false;
          alertMessage = alertMessage.concat(Strings.FIRST_SUBNETWORK_START_LESS_THAN_FINISH);
        }

      }
      else {
        doAddressFieldsHaveProblem = false;
        alertMessage = alertMessage.concat(Strings.FIRST_SUBNETWORK_HAS_UNFILLED_FIELDS);
      }
    }

    if (!this.isLineBlank(2)) {
      if (this.isWholeLineFilled(2)) {
        if (this.isFirstAddressSmallerThanLast(
          document.getElementById("first-ip-2").value,
          document.getElementById("last-ip-2").value)) {
          if (this.isSubnetworkLineIPValid(2)) {
            numOfLines++;

            secondSubnetwork = {
              subNetwork: document.getElementById("subnetwork-2").value,
              firstIp: parseInt(document.getElementById("first-ip-2").value, 10).toString(),
              lastIp: parseInt(document.getElementById("last-ip-2").value, 10).toString()
            };

            sweepData.subNetworkData.push(secondSubnetwork);
          }
          else {
            doAddressFieldsHaveProblem = false;
            alertMessage = alertMessage.concat(Strings.SECOND_SUBNETWORK_ADDRESS_NOT_VALID);
          }
        }
        else {
          doAddressFieldsHaveProblem = false;
          alertMessage = alertMessage.concat(Strings.SECOND_SUBNETWORK_START_LESS_THAN_FINISH);
        }
      }
      else {
        doAddressFieldsHaveProblem = false;
        alertMessage = alertMessage.concat(Strings.SECOND_SUBNETWORK_HAS_UNFILLED_FIELDS);
      }
    }

    if (!this.isLineBlank(3)) {
      if (this.isWholeLineFilled(3)) {
        if (this.isFirstAddressSmallerThanLast(
          document.getElementById("first-ip-3").value,
          document.getElementById("last-ip-3").value)) {
          if (this.isSubnetworkLineIPValid(3)) {
            numOfLines++;

            thirdSubnetwork = {
              subNetwork: document.getElementById("subnetwork-3").value,
              firstIp: parseInt(document.getElementById("first-ip-3").value, 10).toString(),
              lastIp: parseInt(document.getElementById("last-ip-3").value, 10).toString()
            };

            sweepData.subNetworkData.push(thirdSubnetwork);
          }
          else {
            doAddressFieldsHaveProblem = false;
            alertMessage = alertMessage.concat(Strings.THIRD_SUBNETWORK_ADDRESS_NOT_VALID);
          }
        }
        else {
          doAddressFieldsHaveProblem = false;
          alertMessage = alertMessage.concat(Strings.THIRD_SUBNETWORK_START_LESS_THAN_FINISH);
        }

      }
      else {
        doAddressFieldsHaveProblem = false;
        alertMessage = alertMessage.concat(Strings.THIRD_SUBNETWORK_HAS_UNFILLED_FIELDS);
      }
    }

    if (!this.isLineBlank(4)) {
      if (this.isWholeLineFilled(4)) {
        if (this.isFirstAddressSmallerThanLast(
          document.getElementById("first-ip-4").value,
          document.getElementById("last-ip-4").value)) {
          if (this.isSubnetworkLineIPValid(4)) {
            numOfLines++;

            fourthSubnetwork = {
              subNetwork: document.getElementById("subnetwork-4").value,
              firstIp: parseInt(document.getElementById("first-ip-4").value, 10).toString(),
              lastIp: parseInt(document.getElementById("last-ip-4").value, 10).toString()
            };

            sweepData.subNetworkData.push(fourthSubnetwork);
          }
          else {
            doAddressFieldsHaveProblem = false;
            alertMessage = alertMessage.concat(Strings.FOURTH_SUBNETWORK_ADDRESS_NOT_VALID);
          }
        }
        else {
          doAddressFieldsHaveProblem = false;
          alertMessage = alertMessage.concat(Strings.FOURTH_SUBNETWORK_START_LESS_THAN_FINISH);
        }
      }
      else {
        doAddressFieldsHaveProblem = false;
        alertMessage = alertMessage.concat(Strings.FOURTH_SUBNETWORK_HAS_UNFILLED_FIELDS);
      }
    }

    if (!this.isLineBlank(5)) {
      if (this.isWholeLineFilled(5)) {
        if (this.isFirstAddressSmallerThanLast(
          document.getElementById("first-ip-5").value,
          document.getElementById("last-ip-5").value)) {
          if (this.isSubnetworkLineIPValid(5)) {
            numOfLines++;

            fifthSubnetwork = {
              subNetwork: document.getElementById("subnetwork-5").value,
              firstIp: parseInt(document.getElementById("first-ip-5").value, 10).toString(),
              lastIp: parseInt(document.getElementById("last-ip-5").value, 10).toString()
            };

            sweepData.subNetworkData.push(fifthSubnetwork);
          }
          else {
            doAddressFieldsHaveProblem = false;
            alertMessage = alertMessage.concat(Strings.FIFTH_SUBNETWORK_ADDRESS_NOT_VALID);
          }
        }
        else {
          doAddressFieldsHaveProblem = false;
          alertMessage = alertMessage.concat(Strings.FIFTH_SUBNETWORK_START_LESS_THAN_FINISH);
        }
      }
      else {
        doAddressFieldsHaveProblem = false;
        alertMessage = alertMessage.concat(Strings.FIFTH_SUBNETWORK_HAS_UNFILLED_FIELDS);
      }
    }

    if (!doAddressFieldsHaveProblem) {
      alert(alertMessage);
    }
    else {
      // If no subnetworks ranges were specified
      if (sweepData.default === false && numOfLines === 0) {
        alert(Strings.SPECIFY_AT_LEAST_ONE_SUBNETWORK);
      }
      else {
        let notOnSameNetworkAlertMessage = Strings.UNABLE_TO_SAVE_CUSTOM_SWEEP;
        let areAllAdressesOnTheSameNetwork = true;

        // If not all IP addresses can be read by the monitor
        for (let i = 0; i < sweepData.subNetworkData.length; i++) {
          if (!this.verifyIfIPsAreOnNetwork(sweepData.subNetworkData[i])) {
            notOnSameNetworkAlertMessage = notOnSameNetworkAlertMessage.concat("\n" + Strings._THE + (i + 1) + Strings.BAND_HAS_IPS_NOT_IN_SUBNETWORK);
            areAllAdressesOnTheSameNetwork = false;
          }
        }

        if (!areAllAdressesOnTheSameNetwork) {
          alert(notOnSameNetworkAlertMessage);
        }
        else {
          let data = JSON.stringify(sweepData);

          this.showSweepDimmer();

          fetch(Constants.REQUEST_IP_ADDRESS + "subNetworkSweepData_POST", {
            method: "POST",
            headers: {
              "Content-Type": "application/json;charset=UTF-8"
            },
            body: data
          }).then(UtilsInstance.checkStatus)
            .then(() => {
              alert(Strings.SWEEP_DATA_SENT_SUCCESSFULLY);
            })
            .catch((error) => {
              alert(Strings.SWEEP_DATA_SENT_ERROR + "\n" + Strings.REASON_DP + error);
            })
            .finally(this.hideSweepDimmer);
        }
      }
    }

  }

  isFirstAddressSmallerThanLast = (first, last) => {
    if (parseInt(first, 10) < parseInt(last, 10)) {
      return true;
    }
    else {
      return false;
    }
  }

  isLineBlank = (line) => {
    if (line === 1) {
      // If there is nothing written on this line
      if (document.getElementById("subnetwork-1").value === ""
        && document.getElementById("first-ip-1").value === ""
        && document.getElementById("last-ip-1").value === "") {
        return true;
      }
      else {
        return false;
      }
    }
    else if (line === 2) {
      // If there is nothing written on this line
      if (document.getElementById("subnetwork-2").value === ""
        && document.getElementById("first-ip-2").value === ""
        && document.getElementById("last-ip-2").value === "") {
        return true;
      }
      else {
        return false;
      }
    }
    else if (line === 3) {
      // If there is nothing written on this line
      if (document.getElementById("subnetwork-3").value === ""
        && document.getElementById("first-ip-3").value === ""
        && document.getElementById("last-ip-3").value === "") {
        return true;
      }
      else {
        return false;
      }
    }
    else if (line === 4) {
      // If there is nothing written on this line
      if (document.getElementById("subnetwork-4").value === ""
        && document.getElementById("first-ip-4").value === ""
        && document.getElementById("last-ip-4").value === "") {
        return true;
      }
      else {
        return false;
      }
    }
    else if (line === 5) {
      // If there is nothing written on this line
      if (document.getElementById("subnetwork-5").value === ""
        && document.getElementById("first-ip-5").value === ""
        && document.getElementById("last-ip-5").value === "") {
        return true;
      }
      else {
        return false;
      }
    }
  }

  isWholeLineFilled = (line) => {
    if (line === 1) {
      // If one of the fields on the first subnetwork line was filled
      if (document.getElementById("subnetwork-1").value !== ""
        || document.getElementById("first-ip-1").value !== ""
        || document.getElementById("last-ip-1").value !== "") {
        // then only let the user send this data if all of the fields were filled
        if (document.getElementById("subnetwork-1").value !== ""
          && document.getElementById("first-ip-1").value !== ""
          && document.getElementById("last-ip-1").value !== "") {
          return true;
        }
        else {
          return false;
        }
      }
    }
    else if (line === 2) {
      // If one of the fields on the second subnetwork line was filled
      if (document.getElementById("subnetwork-2").value !== ""
        || document.getElementById("first-ip-2").value !== ""
        || document.getElementById("last-ip-2").value !== "") {
        // then only let the user send this data if all of the fields were filled
        if (document.getElementById("subnetwork-2").value !== ""
          && document.getElementById("first-ip-2").value !== ""
          && document.getElementById("last-ip-2").value !== "") {
          return true;
        }
        else {
          return false;
        }
      }
    }
    else if (line === 3) {
      // If one of the fields on the third subnetwork line was filled
      if (document.getElementById("subnetwork-3").value !== ""
        || document.getElementById("first-ip-3").value !== ""
        || document.getElementById("last-ip-3").value !== "") {
        // then only let the user send this data if all of the fields were filled
        if (document.getElementById("subnetwork-3").value !== ""
          && document.getElementById("first-ip-3").value !== ""
          && document.getElementById("last-ip-3").value !== "") {
          return true;
        }
        else {
          return false;
        }
      }
    }
    else if (line === 4) {
      // If one of the fields on the fourth subnetwork line was filled
      if (document.getElementById("subnetwork-4").value !== ""
        || document.getElementById("first-ip-4").value !== ""
        || document.getElementById("last-ip-4").value !== "") {
        // then only let the user send this data if all of the fields were filled
        if (document.getElementById("subnetwork-4").value !== ""
          && document.getElementById("first-ip-4").value !== ""
          && document.getElementById("last-ip-4").value !== "") {
          return true;
        }
        else {
          return false;
        }
      }
    }
    else if (line === 5) {
      // If one of the fields on the fifth subnetwork line was filled
      if (document.getElementById("subnetwork-5").value !== ""
        || document.getElementById("first-ip-5").value !== ""
        || document.getElementById("last-ip-5").value !== "") {
        // then only let the user send this data if all of the fields were filled
        if (document.getElementById("subnetwork-5").value !== ""
          && document.getElementById("first-ip-5").value !== ""
          && document.getElementById("last-ip-5").value !== "") {
          return true;
        }
        else {
          return false;
        }
      }
    }
  }

  isSubnetworkLineIPValid = (line) => {
    if (line === 1) {
      if (UtilsInstance.validateSubnetworkIPAddress(document.getElementById("subnetwork-1").value)) {
        return true;
      }
      else {
        return false;
      }
    }
    else if (line === 2) {
      if (UtilsInstance.validateSubnetworkIPAddress(document.getElementById("subnetwork-2").value)) {
        return true;
      }
      else {
        return false;
      }
    }
    else if (line === 3) {
      if (UtilsInstance.validateSubnetworkIPAddress(document.getElementById("subnetwork-3").value)) {
        return true;
      }
      else {
        return false;
      }
    }
    else if (line === 4) {
      if (UtilsInstance.validateSubnetworkIPAddress(document.getElementById("subnetwork-4").value)) {
        return true;
      }
      else {
        return false;
      }
    }
    else if (line === 5) {
      if (UtilsInstance.validateSubnetworkIPAddress(document.getElementById("subnetwork-5").value)) {
        return true;
      }
      else {
        return false;
      }
    }
  }

  verifyIfIPsAreOnNetwork = (subNetworkData) => {
    let areAddressesOnNetwork = true;

    if (!this.state.networkNetmask.contains(subNetworkData.subNetwork + "." + subNetworkData.firstIp)) {
      areAddressesOnNetwork = false;
    }

    if (!this.state.networkNetmask.contains(subNetworkData.subNetwork + "." + subNetworkData.lastIp)) {
      areAddressesOnNetwork = false;
    }

    return areAddressesOnNetwork;
  }

  // Verifies if the user has the credentials to be logged in
  // If he does he is re-directed to the configuration page
  // If he doesn't he is re-directed to the login page
  isUserLoggedIn = () => {
    if (sessionStorage.auth !== Constants.AUTH_STR) {
      this.props.history.push({ pathname: "/login" });
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.isUserLoggedIn();
    this.retrieveData();
  }

  render() {
    return (
      <Container className="ts-config-subpage ts-config-sweep-page">
        <Segment style={segmentStyle}>
          <Divider horizontal>{Strings.PERSONALIZED_SWEEP}</Divider>
          <Form style={checkboxFormStyle}>
            <Form.Field inline>
              <Checkbox
                toggle
                label={<label id="manual-checkbox-label">{Strings.SWEEP_OFF}</label>}
                onChange={this.toggleCheckbox}
                checked={this.state.isManualSweepChecked}
              />
            </Form.Field>
          </Form>
          <br />
          <Divider horizontal>{Strings.BANDS}</Divider>
          <Form style={rangeFormStyle} onSubmit={this.sendSweepInformation}>
            <Form.Group widths="16">
              <Form.Input id="subnetwork-1" label={Strings.FIRST_BAND} placeholder="192.168.2" width={10}></Form.Input>
              <Form.Input type="number" min="0" max="255" id="first-ip-1" label={Strings.BEGINNING} placeholder="0" width={3}></Form.Input>
              <Form.Input type="number" min="0" max="255" id="last-ip-1" label={Strings.END} placeholder="255" width={3}></Form.Input>
            </Form.Group>

            <Form.Group>
              <Form.Input id="subnetwork-2" label={Strings.SECOND_BAND} placeholder="192.168.3" width={10}></Form.Input>
              <Form.Input type="number" min="0" max="255" id="first-ip-2" label={Strings.BEGINNING} placeholder="0" width={3}></Form.Input>
              <Form.Input type="number" min="0" max="255" id="last-ip-2" label={Strings.END} placeholder="255" width={3}></Form.Input>
            </Form.Group>

            <Form.Group>
              <Form.Input id="subnetwork-3" label={Strings.THIRD_BAND} placeholder="192.168.4" width={10}></Form.Input>
              <Form.Input type="number" min="0" max="255" id="first-ip-3" label={Strings.BEGINNING} placeholder="0" width={3}></Form.Input>
              <Form.Input type="number" min="0" max="255" id="last-ip-3" label={Strings.END} placeholder="255" width={3}></Form.Input>
            </Form.Group>

            <Form.Group>
              <Form.Input id="subnetwork-4" label={Strings.FOURTH_BAND} placeholder="192.168.5" width={10}></Form.Input>
              <Form.Input type="number" min="0" max="255" id="first-ip-4" label={Strings.BEGINNING} placeholder="0" width={3}></Form.Input>
              <Form.Input type="number" min="0" max="255" id="last-ip-4" label={Strings.END} placeholder="255" width={3}></Form.Input>
            </Form.Group>

            <Form.Group>
              <Form.Input id="subnetwork-5" label={Strings.FIFTH_BAND} placeholder="192.168.6" width={10}></Form.Input>
              <Form.Input type="number" min="0" max="255" id="first-ip-5" label={Strings.BEGINNING} placeholder="0" width={3}></Form.Input>
              <Form.Input type="number" min="0" max="255" id="last-ip-5" label={Strings.END} placeholder="255" width={3}></Form.Input>
            </Form.Group>

            <div style={buttonStyle}>
              <Form.Button color="teal">{Strings.SAVE}</Form.Button>
            </div>
          </Form>

          <Dimmer active={this.state.isSweepDimmerActive}>
            <Loader>{Strings.SENDING_DATA}</Loader>
          </Dimmer>
        </Segment>
      </Container>
    );
  }
}

const checkboxFormStyle = {
  textAlign: "center",
  verticalAlign: "middle"
};

const rangeFormStyle = {
  margin: "0 auto",
};

const buttonStyle = {
  textAlign: "center"
};

const segmentStyle = {
  marginBottom: "2vh"
};

export default Sweep;
